import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TargetProgressOngoingComponent } from '../target-progress-ongoing/target-progress-ongoing.component';
import { TargetProgressTodoComponent } from "../target-progress-todo/target-progress-todo.component";
import { TargetOutForDeliveryComponent } from "../target-out-for-delivery/target-out-for-delivery.component";

@Component({
  selector: 'app-target-progress-all',
  standalone: true,
  imports: [CommonModule, FormsModule, TargetProgressOngoingComponent, TargetProgressTodoComponent, TargetOutForDeliveryComponent],
  templateUrl: './target-progress-all.component.html',
  styleUrl: './target-progress-all.component.css'
})
export class TargetProgressAllComponent implements OnInit {

  isSelectAll: boolean = true;
  isSelectToDo: boolean = false;
  isSelectOutForDelivery: boolean = false;

  constructor() { }

  ngOnInit(): void { }

  onSwitchToOutForDelivery() {
    this.selectOutForDelivery();
  }

  selectAll() {
    this.isSelectAll = true;
    this.isSelectToDo = false;
    // this.isSelectCompleted = false;
    this.isSelectOutForDelivery = false;
  }

  selectToDo() {
    this.isSelectAll = false;
    this.isSelectToDo = true;
    this.isSelectOutForDelivery = false;
  }

  selectOutForDelivery() {
    this.isSelectAll = false;
    this.isSelectToDo = false;
    this.isSelectOutForDelivery = true;
  }

}
